import { FC } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Button, ButtonProps } from '@/shared/uikit/Button';

export const ButtonWithLoaderIw: FC<ButtonProps> = ({ children, loading, ...props }) => {
  return (
    <StyledButton {...props} $loading={Boolean(loading)}>
      {loading ? (
        <>
          <div style={{ visibility: 'hidden' }}>{children}</div>

          <SpinWrapper>
            <SpinAnimated />
          </SpinWrapper>
        </>
      ) : (
        children
      )}
    </StyledButton>
  );
};

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const SpinAnimated = styled.div`
  width: 20px;
  height: 20px;

  animation: ${spin} 1s linear infinite;
  border: 2px solid ${COLORS.white};
  border-top-color: transparent;
  border-radius: 100%;
`;

const StyledButton = styled(Button)<{ $loading: boolean }>`
  ${(p) =>
    p.$loading &&
    css`
      &.ant-btn:disabled {
        background-color: ${COLORS.systemDark200};
        opacity: 0.5;
        border: none;
      }
    `}
`;
